ready().then(function() {

    // based on page template
    if($('body').hasClass('single-wpg_book')) {
        
        /**
         * Change the mobile layout
         */
        const reorderMobileElements = () => {
            const pageTitle = $('.page-title');
            const pageSubTitle = $('.page-subtitle');
            const bookAuthors = $('.book-authors');
            const awards = $('.awards-section');
            let coverHolder = $('.col-cover-holder');
            let bookSummary = $('.section-book-summary .col').eq(1);

            if(bookAuthors.length > 0) {
                coverHolder.prepend(bookAuthors);
            }
            if(pageSubTitle.length > 0) {
                coverHolder.prepend(pageSubTitle);
            }
            if(pageTitle.length > 0) {
                coverHolder.prepend(pageTitle);
            }
            if(awards.length > 0) {
                bookSummary.append(awards);
            }

        }

        if (window.screen.width < mdWidth ) { // Only on the smallest devices
            reorderMobileElements();
        }
    }
    
});